import React from 'react'
import {
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel
} from '@mui/material'
import { getSectionLayoutSettings } from '../../../utils/themeSectionLayout'
import SectionSpacingFields from './shared/SectionSpacingFields'
import useTranslation from '../../../hooks/useTranslation'

export default function ProductCatalogSettings({ settings, onChange }) {
  const { t } = useTranslation()
  const { columns, rows } = getSectionLayoutSettings(settings)

  return (
    <Stack spacing={2}>
      <SectionSpacingFields
        settings={settings}
        onChange={onChange}
      />

      <Stack direction="row" spacing={2}>
        <TextField
          label={t('labels.themes.columns')}
          type="number"
          size="small"
          fullWidth
          inputProps={{ min: 2, max: 6 }}
          value={columns}
          onChange={(e) => onChange({
            ...settings,
            columns: parseInt(e.target.value, 10) || 4
          })}
        />

        <TextField
          label={t('labels.themes.rows')}
          type="number"
          size="small"
          fullWidth
          inputProps={{ min: 1, max: 10 }}
          value={rows}
          onChange={(e) => onChange({
            ...settings,
            rows: parseInt(e.target.value, 10) || 3
          })}
        />
      </Stack>

      <FormControl size="small" fullWidth>
        <InputLabel>{t('labels.themes.defaultSort')}</InputLabel>
        <Select
          value={settings.sortBy || 'date_desc'}
          label={t('labels.themes.defaultSort')}
          onChange={(e) => onChange({
            ...settings,
            sortBy: e.target.value
          })}
        >
          <MenuItem value="name_asc">{t('labels.themes.sortOptions.nameAsc')}</MenuItem>
          <MenuItem value="name_desc">{t('labels.themes.sortOptions.nameDesc')}</MenuItem>
          <MenuItem value="price_asc">{t('labels.themes.sortOptions.priceAsc')}</MenuItem>
          <MenuItem value="price_desc">{t('labels.themes.sortOptions.priceDesc')}</MenuItem>
          <MenuItem value="latest">{t('labels.themes.sortOptions.latest')}</MenuItem>
          <MenuItem value="oldest">{t('labels.themes.sortOptions.oldest')}</MenuItem>
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Switch
            checked={settings.showSorting !== false}
            onChange={(e) => onChange({
              ...settings,
              showSorting: e.target.checked
            })}
          />
        }
        label={t('labels.themes.showSortingDropdown')}
      />

      <FormControlLabel
        control={
          <Switch
            checked={settings.showLoadMore !== false}
            onChange={(e) => onChange({
              ...settings,
              showLoadMore: e.target.checked
            })}
          />
        }
        label={t('labels.themes.showLoadMoreButton')}
      />
    </Stack>
  )
}